import { fetchIndustriousMicroLocations } from '@/lib/locations/location-api';
import { mapLocationsToOptions } from '@/utils/locations';

import Newsletter from './Newsletter';

export default async function NewsletterWrapper({
  locale,
}: {
  locale: string;
}) {
  const locations = await fetchIndustriousMicroLocations(locale);
  const locationOptions = mapLocationsToOptions(locations);

  return <Newsletter locationOptions={locationOptions} locale={locale} />;
}
